import React from 'react';
import { Shield } from 'lucide-react';
import { Button } from './ui/Button';
import { Badge } from './ui/Badge';
export function Hero() {
  return <section className="relative pt-8 pb-8 md:pt-24 md:pb-16 px-4 max-w-5xl mx-auto w-full flex flex-col items-center text-center overflow-hidden" data-id="element-81">
      <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-sky-900/30 rounded-full blur-[120px] -z-10" data-id="element-82" />

      <div className="flex items-center gap-2 text-sky-400 font-bold tracking-[0.2em] uppercase mb-6 md:mb-10 text-xs md:text-sm" data-id="element-83">
        <Shield className="w-4 h-4 md:w-5 md:h-5" data-id="element-84" />
        DIGITALPREMIUM™
      </div>

      <h1 className="text-3xl md:text-5xl lg:text-6xl font-black tracking-tight mb-8 md:mb-12 text-white leading-[1.2] max-w-3xl" data-id="element-85">
        Protegé a tus hijos en el mundo digital.{' '}
        <span className="text-sky-400" data-id="element-86">Desde hoy.</span>
      </h1>

      <div className="w-full flex justify-center mb-0 md:mb-1" data-id="element-87">
        <div className="relative w-[240px] md:w-[420px] lg:w-[500px]" data-id="element-88">
          <img src="https://cdn.magicpatterns.com/uploads/1KKExGnqz8fVcbttYyGqVL/posta_-_Editado.png?width=480" alt="Pack de Seguridad Digital para Padres" width={480} height={480} fetchPriority="high" loading="eager" decoding="async" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-89" />
        </div>
      </div>

      <div className="max-w-3xl mx-auto space-y-2 md:space-y-3 mb-8 md:mb-10 px-2 mt-8 md:mt-12" data-id="element-90">
        <p className="text-sm md:text-lg text-sky-400 font-bold leading-snug" data-id="element-91">
          Sistema Completo de Seguridad Digital para Padres
        </p>
        <p className="text-[12px] md:text-sm text-slate-300 leading-relaxed max-w-2xl mx-auto" data-id="element-92">
          El recurso esencial para padres en Argentina que quieren entender,
          prevenir y actuar frente a los riesgos en redes sociales.
        </p>
      </div>

      <div className="flex flex-row flex-wrap justify-center gap-1.5 md:gap-3 mb-8 md:mb-12 w-full max-w-none" data-id="element-93">
        <Badge icon={<span className="text-[10px] md:text-xs" data-id="element-95">📄</span>} data-id="element-94">
          100% PDF
        </Badge>
        <Badge icon={<span className="text-[10px] md:text-xs" data-id="element-97">⚡</span>} data-id="element-96">
          Acceso en 5 minutos
        </Badge>
        <Badge icon={<span className="text-[10px] md:text-xs" data-id="element-99">🛡️</span>} data-id="element-98">
          Seguridad
        </Badge>
      </div>

      <div className="w-full max-w-[320px] md:max-w-md flex flex-col items-center gap-3 md:gap-6" data-id="element-100">
        <Button fullWidth onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-101">
          QUIERO MI MEGAPACK AHORA
        </Button>

        <div className="flex items-center justify-center gap-3 md:gap-6 text-[10px] md:text-sm text-slate-400 font-medium" data-id="element-102">
          <span className="flex items-center gap-1" data-id="element-103">
            <span className="text-sm md:text-base" data-id="element-104">✅</span> Garantía 7 días
          </span>
          <span className="flex items-center gap-1" data-id="element-105">
            <span className="text-sm md:text-base" data-id="element-106">🔒</span> Pago seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-107">
            <span className="text-sm md:text-base" data-id="element-108">💳</span> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}